export default {
  id: null,
  companyID: null,
  groupID: null,
  expertID: null,
  mechanicalWorkshopID: null,
  name: null,
  avatar: null,
  cellPhone: null,
  cpf: null,
  isAnalyst: null,
  email: null,
  password: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/accountmodel.js